module.exports = __webpack_public_path__ + "a27fc2e0bcd837e9576d8a396478fca5.svg";